
import QRcode from 'qrcode'

export function splitArrayChunk(arr, chunk) {
  let res = []
  for (let k = 0; k < arr.length; k += chunk) {
    let temp = arr.slice(k, k + chunk)
    res.push(temp)
  }
  return res
}

// 生成二维码
export async function createQRcode (url) {
  let opts = {
    errorCorrectionLevel: 'H',
    type: 'image/png',
    quality: 0.7,
    margin: 3,
    color: {
      dark: '#000',
      light: '#fff'
    }
  }
  const qrcode = await QRcode.toDataURL(url, opts)
  return qrcode
}

export function getURLSearchParams (key) {
  if (!key) return
  let URLParams = new URLSearchParams(window.location.search)
  URLParams = URLParams.get(key)
  return URLParams || ''
}

// 身份证号脱敏
export function idDesensitization (value) {
  return value.replace(/^(.{1})(?:\d+)(.{1})$/, '$1****************$2')
}
